import { render, staticRenderFns } from "./industrial-design.vue?vue&type=template&id=3ba96066&scoped=true&"
import script from "./industrial-design.vue?vue&type=script&lang=js&"
export * from "./industrial-design.vue?vue&type=script&lang=js&"
import style0 from "./industrial-design.vue?vue&type=style&index=0&id=3ba96066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba96066",
  null
  
)

export default component.exports